module.exports = __webpack_public_path__ + "media/images/yen-7e63f4d7c03af1dd83568dadb55c9dff.svg";